var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-testid":"select-wrapper"}},[_c('v-select',{attrs:{"value":_vm.select,"items":_vm.timeFrames,"label":_vm.label,"item-text":_vm.itemText,"item-value":_vm.itemValue,"outlined":""},on:{"input":_vm.timestampUpdated}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }